import { TYPE_LABELS } from 'lib/constants/transaction/typeLabels';
import { formatDateAndTime, ia, pm, snakeToTitleCase } from 'lib/helpers/utility';

import CardProcessor from 'components/shared/CardProcessor';

import Actions from '../Actions';
import AmountPaidSelf from '../AmountPaidSelf';

export const getColDefs = ({
  isFromPractice = false,
  isFromAdminPractice = false,
  isFromAdminPatient = false,
  isFromPatient = false,
  timezone,
  permissions = {}
}) => [
  {
    field: 'id',
    headerName: 'ID',
    maxWidth: 120
  },
  ...(isFromAdminPractice
    ? [
        {
          field: 'patient.fullName',
          headerName: 'Patient',
          width: 300,
          valueFormatter: ({ value }) => (value ? value : '-')
        }
      ]
    : []),
  ...(isFromAdminPatient
    ? [
        {
          field: 'practice_id',
          headerName: 'Practice',
          width: 300,
          valueFormatter: ({ value }) => (value ? value : '-')
        }
      ]
    : []),
  ...(isFromPatient
    ? [
        {
          field: 'practice.name',
          headerName: 'Practice Name',
          valueFormatter: ({ value }) => (value ? value : '-')
        }
      ]
    : []),
  {
    field: 'created_at',
    headerName: 'Date',
    valueFormatter: ({ value }) =>
      timezone
        ? value
          ? formatDateAndTime(value, timezone)
          : '-'
        : value
          ? formatDateAndTime(value)
          : '-'
  },
  {
    field: 'status',
    headerName: 'Status',
    valueFormatter: ({ value }) => (value ? snakeToTitleCase(value) : '-')
  },
  {
    field: 'type',
    headerName: 'Type',
    valueFormatter: ({ value }) => (value ? TYPE_LABELS[value] : '-')
  },
  {
    field: 'cc_type',
    headerName: 'Card Type',
    cellRenderer: ({ value }) => {
      return value ? (
        <div className="flex items-center justify-center pt-[8px]">
          <CardProcessor>{value}</CardProcessor>
        </div>
      ) : (
        '-'
      );
    }
  },
  {
    field: 'cc_number',
    headerName: 'Card Number (Last 4)',
    valueFormatter: ({ value }) => (value ? value : '-')
  },
  ...(isFromPractice
    ? pm(permissions, 'payments.read')
      ? [
          {
            field: 'amount_paid_self',
            headerName: 'Amount',
            initialWidth: 260,
            cellRenderer: ({ value, data }) => {
              return <AmountPaidSelf value={value} data={data} />;
            },
            aggFunc: 'sum',
            sortable: false
          }
        ]
      : []
    : [
        {
          field: 'amount_paid_self',
          headerName: 'Amount',
          initialWidth: 260,
          cellRenderer: ({ value, data }) => {
            return <AmountPaidSelf value={value} data={data} />;
          },
          aggFunc: 'sum',
          sortable: false
        }
      ]),

  {
    field: 'cashier_name',
    headerName: 'Cashier',
    valueFormatter: ({ value }) => (value ? value : '-')
  },
  {
    field: 'appointment.resources',
    headerName: 'Resource',
    valueFormatter: ({ value }) => (ia(value) ? value[0]?.name : '-'),
    sortable: false
  },
  ...(isFromPractice
    ? [
        {
          field: 'actions',
          headerName: 'Actions',
          cellRenderer: Actions,
          cellClass: 'no-border',
          maxWidth: 88,
          minWidth: 36,
          resizable: false,
          sortable: false,
          pinned: 'right'
        }
      ]
    : isFromAdminPatient || isFromAdminPractice
      ? [
          {
            field: 'actions',
            headerName: 'Actions',
            maxWidth: 88,
            minWidth: 36,
            resizable: false,
            sortable: false,
            pinned: 'right',
            cellRenderer: (params) => (
              <Actions key={`${params.data.id}-transaction-actions`} data={params.data} />
            )
          }
        ]
      : isFromPatient
        ? [
            {
              field: 'actions',
              headerName: 'Actions',
              cellRenderer: (params) => (
                <Actions
                  data={{
                    ...params.data,
                    isPatient: true
                  }}
                />
              ),
              maxWidth: 88,
              minWidth: 36,
              resizable: false,
              sortable: false,
              pinned: 'right',
              no_show_csv: true
            }
          ]
        : [])
];

export const DEFAULT_COLUMN_DEFS = {
  enableRowGroup: true
};

export const GRID_OPTIONS = {
  animateRows: true,
  rowGroupPanelShow: 'always',
  enableRangeSelection: true,
  showOpenedGroup: true,
  suppressAggFuncInHeader: true,
  autoGroupColumnDef: {
    pinned: 'left',
    sortable: false
  }
};
